import React, { useEffect } from 'react';
import { Box, Container, Typography, Button, Breadcrumbs, Link } from '@mui/material';
import TarefasArquivadas from '../components/tarefas/TarefasArquivadas';
import { useKanban } from '../contexts/KanbanContext';
import { Link as RouterLink } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const TarefasArquivadasPage: React.FC = () => {
  const { carregarTarefasArquivadas } = useKanban();

  // Não precisamos carregar as tarefas arquivadas aqui, pois isso já é feito no KanbanContext
  // quando o usuário é autenticado

  return (
    <Container maxWidth="xl">
      <Box sx={{ mt: 3, mb: 4 }}>
        <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
          <Link component={RouterLink} to="/" color="inherit">
            Dashboard
          </Link>
          <Typography color="text.primary">Tarefas Arquivadas</Typography>
        </Breadcrumbs>

        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
          <Typography variant="h4" component="h1">
            Tarefas Arquivadas
          </Typography>
          <Button 
            component={RouterLink} 
            to="/kanban" 
            variant="outlined" 
            startIcon={<ArrowBackIcon />}
          >
            Voltar ao Quadro
          </Button>
        </Box>

        <TarefasArquivadas />
      </Box>
    </Container>
  );
};

export default TarefasArquivadasPage;
